// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bd":"bd-C_bRxXtj","space40":"space40-p0-V--js","space10":"space10-xkIkGnqp"};